// import { useState, useEffect, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { message } from "antd";
// import {
//   checkExtractionHealth,
//   processDocument,
//   fetchDocuments,
//   fetchDocumentById,
//   fetchStatistics,
//   deleteDocument,
//   searchDocuments,
//   fetchMyDocuments,
//   fetchAllRecentDocuments,
//   fetchDocumentsByType,
//   updateDocumentParameters,
//   fetchDocumentHistory,
//   fetchUserStorage,
//   recalculateUserStorage,
//   shareDocument,
//   shareDocuments,
//   fetchDocumentAccessList,
//   revokeDocumentAccess,
// } from "../Redux/thunks/extractionThunks";
// import {
//   selectProcessLoading,
//   selectProcessResult,
//   selectProcessError,
//   selectDocuments,
//   selectDocumentsLoading,
//   selectCurrentDocument,
//   selectDocumentLoading,
//   selectStatistics,
//   selectIsHealthy,
//   selectSearchResults,
//   selectSearchLoading,
//   selectMyDocuments,
//   selectMyDocumentsLoading,
//   selectMyDocumentsError,
//   selectMyDocumentsTotal,
//   selectUpdateLoading,
//   selectUpdateError,
//   selectUpdateSuccess,
//   selectDocumentHistory,
//   selectHistoryLoading,
//   selectHistoryError,
//   selectUserStorage,
//   selectStorageLoading,
//   selectIsStorageFull,
//   selectIsStorageAlmostFull,
//   selectStorageUsedMB,
//   selectStorageQuotaMB,
//   selectStorageAvailableMB,
//    selectShareLoading,
//   selectShareError,
//   selectShareSuccess,
//   selectShareResult,
//   selectBatchShareLoading,
//   selectBatchShareResult,
//   selectAccessList,
//   selectAccessListLoading,
//   selectRevokeLoading,
//   selectRevokeSuccess,
// } from "../redux/selectors/extractionSelectors";
// import {
//   resetProcessResult,
//   resetDocuments,
//   resetMyDocuments,
//   resetCurrentDocument,
//   resetSearchResults,
//   resetUpdateState,
//   resetDocumentHistory,
//   resetShareState,
//   resetBatchShareState,
//   resetAccessList,
//   resetRevokeState,
// } from "../Redux/slices/extractionSlice";
// import { fetchUserById } from "../../Profile/redux/thunks/userThunks";

// // ✅ autoLoad: false pour désactiver le chargement automatique de tous les docs
// export const useExtraction = (overrideUserId = null, { autoLoad = true } = {}) => {
//   const dispatch = useDispatch();

//   const authUserId = useSelector((state) => state.auth?.user?.id || null);
//   useEffect(() => {
//     if (authUserId) {
//       dispatch(fetchUserById(authUserId));
//     }
//   }, [dispatch, authUserId]);

//   const fetchedUser = useSelector((state) =>
//     authUserId ? state.user.users[authUserId] : null
//   );
//   const patientId = overrideUserId || fetchedUser?.id || authUserId || null;


//   // Selectors
//   const processLoading = useSelector(selectProcessLoading);
//   const processResult = useSelector(selectProcessResult);
//   const processError = useSelector(selectProcessError);
//   const documents = useSelector(selectDocuments);
//   const documentsLoading = useSelector(selectDocumentsLoading);
//   const currentDocument = useSelector(selectCurrentDocument);
//   const documentLoading = useSelector(selectDocumentLoading);
//   const statistics = useSelector(selectStatistics);
//   const isHealthy = useSelector(selectIsHealthy);
//   const searchResults = useSelector(selectSearchResults);
//   const searchLoading = useSelector(selectSearchLoading);
//   const myDocuments = useSelector(selectMyDocuments);
//   const myDocumentsLoading = useSelector(selectMyDocumentsLoading);
//   const myDocumentsError = useSelector(selectMyDocumentsError);
//   const myDocumentsTotal = useSelector(selectMyDocumentsTotal);
//   const updateLoading = useSelector(selectUpdateLoading);
//   const updateError = useSelector(selectUpdateError);
//   const updateSuccess = useSelector(selectUpdateSuccess);
//   const documentHistory = useSelector(selectDocumentHistory);
//   const historyLoading = useSelector(selectHistoryLoading);
//   const historyError = useSelector(selectHistoryError);
//   const userStorage = useSelector(selectUserStorage);
//   const storageLoading = useSelector(selectStorageLoading);
//   const isStorageFull = useSelector(selectIsStorageFull);
//   const isStorageAlmostFull = useSelector(selectIsStorageAlmostFull);
//   const storageUsedMB = useSelector(selectStorageUsedMB);
//   const storageQuotaMB = useSelector(selectStorageQuotaMB);
//   const storageAvailableMB = useSelector(selectStorageAvailableMB);

//   // Local state
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [previewUrl, setPreviewUrl] = useState(null);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showAnalysisModal, setShowAnalysisModal] = useState(false);
//   const [showResultsModal, setShowResultsModal] = useState(false);
//   const [analysisSteps, setAnalysisSteps] = useState([
//     { key: 1, label: "Document Classification", completed: false },
//     { key: 2, label: "OCR Processing", completed: false },
//     { key: 3, label: "Data Extraction", completed: false },
//     { key: 4, label: "Normalize and Clean Data", completed: false },
//     { key: 5, label: "Anonymization", completed: false },
//   ]);

//   // ✅ Auto-refresh storage
//   useEffect(() => {
//     const userId = patientId || undefined;
//     dispatch(fetchUserStorage(userId));
//     const interval = setInterval(() => {
//       dispatch(fetchUserStorage(userId));
//     }, 30000);
//     return () => clearInterval(interval);
//   }, [dispatch, patientId]);

//   // ✅ Health Check & Statistics
//   useEffect(() => {
//     dispatch(checkExtractionHealth());
//     const userId = patientId || undefined;
//     dispatch(fetchStatistics(userId));
//   }, [dispatch, patientId]);

//   // ✅ Auto-load UNIQUEMENT si autoLoad=true (désactivé dans RecordType)
//   useEffect(() => {
//     if (patientId && autoLoad) {
//       dispatch(fetchMyDocuments({ skip: 0, limit: 50, userId: patientId }));
//     }
//   }, [dispatch, patientId, autoLoad]);

//   // Handle File Selection
//   const handleFileSelect = useCallback((file) => {
//     if (!file) {
//       message.error("Aucun fichier sélectionné");
//       return false;
//     }

//     const allowedTypes = [
//       "application/pdf",
//       "image/jpeg",
//       "image/jpg",
//       "image/png",
//       "image/tiff",
//       "image/bmp",
//     ];

//     if (!allowedTypes.includes(file.type)) {
//       message.error("Type de fichier non supporté. Utilisez PDF ou images.");
//       return false;
//     }

//     const maxSize = 10 * 1024 * 1024;
//     if (file.size > maxSize) {
//       message.error("Fichier trop volumineux. Taille maximale: 10MB");
//       return false;
//     }

//     setSelectedFile(file);

//     if (file.type.startsWith("image/")) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewUrl(reader.result);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPreviewUrl(null);
//     }

//     return false;
//   }, []);

//   // Simulate Analysis Steps
//   const simulateAnalysisSteps = useCallback(() => {
//     const delays = [1000, 1500, 2000, 2500, 1500];
//     setAnalysisSteps((steps) =>
//       steps.map((step) => ({ ...step, completed: false }))
//     );
//     delays.forEach((delay, index) => {
//       setTimeout(() => {
//         setAnalysisSteps((steps) =>
//           steps.map((step, i) =>
//             i === index ? { ...step, completed: true } : step
//           )
//         );
//       }, delays.slice(0, index + 1).reduce((a, b) => a + b, 0));
//     });
//   }, []);

//   // Handle Upload & Process
//   const handleUploadAndAnalyze = useCallback(
//     async (options = {}) => {
//       if (!selectedFile) {
//         message.error("Veuillez sélectionner un fichier");
//         return;
//       }

//       const { device = "auto", redactionMethod = "blackout" } = options;

//       try {
//         setShowAnalysisModal(true);
//         setUploadProgress(0);

//         const progressInterval = setInterval(() => {
//           setUploadProgress((prev) => {
//             if (prev >= 90) {
//               clearInterval(progressInterval);
//               return 90;
//             }
//             return prev + 10;
//           });
//         }, 300);

//         simulateAnalysisSteps();

//         const result = await dispatch(
//           processDocument({ file: selectedFile, device, redactionMethod })
//         ).unwrap();

//         clearInterval(progressInterval);
//         setUploadProgress(100);

//         message.success("Document traité avec succès!");

//         setTimeout(() => {
//           setShowAnalysisModal(false);
//           setShowResultsModal(true);
//           const userId = patientId || undefined;
//           dispatch(fetchStatistics(userId));
//           dispatch(fetchMyDocuments({ skip: 0, limit: 50, userId }));
//           dispatch(fetchUserStorage(userId));
//         }, 1000);

//         setSelectedFile(null);
//         setPreviewUrl(null);
//         setUploadProgress(0);

//         return result;
//       } catch (error) {
//         setShowAnalysisModal(false);
//         message.error(error || "Erreur lors du traitement du document");
//         setUploadProgress(0);
//         return null;
//       }
//     },
//     [selectedFile, dispatch, simulateAnalysisSteps, patientId]
//   );

//   // Handle Save Results
//   const handleSaveResults = useCallback(() => {
//     if (processResult) {
//       message.success("Résultats sauvegardés avec succès!");
//       setShowResultsModal(false);
//       dispatch(resetProcessResult());
//     }
//   }, [processResult, dispatch]);

//   const handleCloseAnalysisModal = useCallback(() => {
//     setShowAnalysisModal(false);
//   }, []);

//   const handleCloseResultsModal = useCallback(() => {
//     setShowResultsModal(false);
//     dispatch(resetProcessResult());
//   }, [dispatch]);

//   // Fetch Documents by Collection
//   const loadDocuments = useCallback(
//     (collection, skip = 0, limit = 10) => {
//       const userId = patientId || undefined;
//       return dispatch(fetchDocuments({ collection, skip, limit, userId }));
//     },
//     [dispatch, patientId]
//   );

//   const loadMyDocuments = useCallback(
//     (skip = 0, limit = 50, overrideUserId = null) => {
//       const userId = overrideUserId || patientId || undefined;
//       return dispatch(fetchMyDocuments({ skip, limit, userId }));
//     },
//     [dispatch, patientId]
//   );

//   const loadAllRecentDocuments = useCallback(
//     (skip = 0, limit = 10) => {
//       const userId = patientId || undefined;
//       return dispatch(fetchAllRecentDocuments({ skip, limit, userId }));
//     },
//     [dispatch, patientId]
//   );

//   const loadDocumentsByType = useCallback(
//     (type, skip = 0, limit = 50) => {
//       const userId = patientId || undefined;
//       return dispatch(fetchDocumentsByType({ type, skip, limit, userId }));
//     },
//     [dispatch, patientId]
//   );

//   const loadDocument = useCallback(
//     (collection, id) => {
//       const userId = patientId || undefined;
//       return dispatch(fetchDocumentById({ collection, id, userId }));
//     },
//     [dispatch, patientId]
//   );

//   const removeDocument = useCallback(
//     async (collection, id) => {

//       if (!id) {
//         message.error("Invalid document ID");
//         return false;
//       }

//       try {
//         const normalizedCollection = String(collection || "autre")
//           .toLowerCase()
//           .replace(/-/g, "_");

//         const result = await dispatch(
//           deleteDocument({ collection: normalizedCollection, id })
//         ).unwrap();

//         message.success("Document deleted!");

//         const userId = patientId || undefined;
//         dispatch(fetchStatistics(userId));
//         dispatch(fetchMyDocuments({ skip: 0, limit: 50, userId }));
//         dispatch(fetchUserStorage(userId));

//         return true;
//       } catch (error) {
//         console.error("[useExtraction] ❌ Delete failed:", error);
//         message.error(error || "Failed to delete document");
//         return false;
//       }
//     },
//     [dispatch, patientId]
//   );

//   const searchDocs = useCallback(
//     (collection, query, field = "nom_fichier") => {
//       const userId = patientId || undefined;
//       return dispatch(searchDocuments({ collection, query, field, userId }));
//     },
//     [dispatch, patientId]
//   );

//   const refreshAllData = useCallback(() => {
//     const userId = patientId || undefined;
//     dispatch(checkExtractionHealth());
//     dispatch(fetchStatistics(userId));
//     dispatch(fetchMyDocuments({ skip: 0, limit: 50, userId }));
//     dispatch(fetchUserStorage(userId));
//   }, [dispatch, patientId]);

//   const resetFileSelection = useCallback(() => {
//     setSelectedFile(null);
//     setPreviewUrl(null);
//     setUploadProgress(0);
//   }, []);

//   const resetAllResults = useCallback(() => {
//     dispatch(resetProcessResult());
//     dispatch(resetDocuments());
//     dispatch(resetMyDocuments());
//     dispatch(resetCurrentDocument());
//     dispatch(resetSearchResults());
//   }, [dispatch]);

//   const updateParameters = useCallback(
//     async (collection, id, updateData) => {
//       try {
//         const result = await dispatch(
//           updateDocumentParameters({ collection, id, updateData })
//         ).unwrap();
//         message.success(`${updateData.modifications?.length || 0} modifications saved!`);
//         const userId = patientId || undefined;
//         dispatch(fetchStatistics(userId));
//         dispatch(fetchMyDocuments({ skip: 0, limit: 50, userId }));
//         dispatch(fetchUserStorage(userId));
//         return result;
//       } catch (error) {
//         console.error("[useExtraction] ❌ Update failed:", error);
//         message.error(error || "Failed to update parameters");
//         return null;
//       }
//     },
//     [dispatch, patientId]
//   );

//   const getDocumentHistory = useCallback(
//     async (collection, id) => {
//       try {
//         const result = await dispatch(
//           fetchDocumentHistory({ collection, id })
//         ).unwrap();
//         return result;
//       } catch (error) {
//         console.error("[useExtraction] ❌ History fetch failed:", error);
//         message.error(error || "Failed to fetch history");
//         return null;
//       }
//     },
//     [dispatch]
//   );

//   const resetUpdate = useCallback(() => {
//     dispatch(resetUpdateState());
//   }, [dispatch]);

//   const getUserStorage = useCallback(async () => {
//     try {
//       const userId = patientId || undefined;
//       await dispatch(fetchUserStorage(userId)).unwrap();
//     } catch (error) {
//       console.error("[useExtraction] ❌ Error fetching storage:", error);
//       throw error;
//     }
//   }, [dispatch, patientId]);

//   const recalculateStorage = useCallback(async () => {
//     try {
//       const userId = patientId || undefined;
//       await dispatch(recalculateUserStorage(userId)).unwrap();
//       dispatch(fetchStatistics(userId));
//     } catch (error) {
//       console.error("[useExtraction] ❌ Error recalculating storage:", error);
//       throw error;
//     }
//   }, [dispatch, patientId]);

//   return {
//     // Local State
//     selectedFile,
//     previewUrl,
//     uploadProgress,
//     showAnalysisModal,
//     showResultsModal,
//     analysisSteps,

//     // Redux State
//     processLoading,
//     processResult,
//     processError,
//     documents,
//     documentsLoading,
//     currentDocument,
//     documentLoading,
//     statistics,
//     isHealthy,
//     searchResults,
//     searchLoading,
//     myDocuments,
//     myDocumentsLoading,
//     myDocumentsError,
//     myDocumentsTotal,
//     updateLoading,
//     updateError,
//     updateSuccess,
//     documentHistory,
//     historyLoading,
//     historyError,
//     userStorage,
//     storageLoading,
//     isStorageFull,
//     isStorageAlmostFull,
//     storageUsedMB,
//     storageQuotaMB,
//     storageAvailableMB,

//     // Actions
//     handleFileSelect,
//     handleUploadAndAnalyze,
//     handleSaveResults,
//     handleCloseAnalysisModal,
//     handleCloseResultsModal,
//     loadDocuments,
//     loadMyDocuments,
//     loadAllRecentDocuments,
//     loadDocumentsByType,
//     loadDocument,
//     removeDocument,
//     searchDocs,
//     refreshAllData,
//     resetFileSelection,
//     resetAllResults,
//     updateParameters,
//     getDocumentHistory,
//     resetUpdate,
//     getUserStorage,
//     recalculateStorage,

//     // Setters
//     setShowAnalysisModal,
//     setShowResultsModal,
//   };
// };

// export default useExtraction;


import { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import {
  checkExtractionHealth,
  processDocument,
  fetchDocuments,
  fetchDocumentById,
  fetchStatistics,
  deleteDocument,
  searchDocuments,
  fetchMyDocuments,
  fetchAllRecentDocuments,
  fetchDocumentsByType,
  updateDocumentParameters,
  fetchDocumentHistory,
  fetchUserStorage,
  recalculateUserStorage,
  shareDocument,
  shareDocuments,
  fetchDocumentAccessList,
  revokeDocumentAccess,
  resolveMedicalRecordScope,
} from "../redux/thunks/extractionThunks";
import {
  selectProcessLoading,
  selectProcessResult,
  selectProcessError,
  selectDocuments,
  selectDocumentsLoading,
  selectCurrentDocument,
  selectDocumentLoading,
  selectStatistics,
  selectIsHealthy,
  selectSearchResults,
  selectSearchLoading,
  selectMyDocuments,
  selectMyDocumentsLoading,
  selectMyDocumentsError,
  selectMyDocumentsTotal,
  selectUpdateLoading,
  selectUpdateError,
  selectUpdateSuccess,
  selectDocumentHistory,
  selectHistoryLoading,
  selectHistoryError,
  selectUserStorage,
  selectStorageLoading,
  selectIsStorageFull,
  selectIsStorageAlmostFull,
  selectStorageUsedMB,
  selectStorageQuotaMB,
  selectStorageAvailableMB,
  selectStorageDocumentCount,
  selectStorageMaxFiles,
  selectStorageAvailableFiles,
  selectShareLoading,
  selectShareError,
  selectShareSuccess,
  selectShareResult,
  selectBatchShareLoading,
  selectBatchShareError,
  selectBatchShareResult,
  selectAccessList,
  selectAccessListLoading,
  selectAccessListError,
  selectRevokeLoading,
  selectRevokeError,
  selectRevokeSuccess,
  selectIsAnySharePending,
  selectActiveAccessList,
  selectExpiredAccessList,
  selectAccessDoctorCount,
} from "../redux/selectors/extractionSelectors";
import {
  resetProcessResult,
  resetDocuments,
  resetMyDocuments,
  resetDocumentsByType,
  resetCurrentDocument,
  resetSearchResults,
  resetUpdateState,
  resetDocumentHistory,
  resetShareState,
  resetBatchShareState,
  resetAccessList,
  resetRevokeState,
} from "../redux/slices/extractionSlice";
import { fetchUserById } from "../../Profile/redux/thunks/userThunks";
import {
  selectEffectiveUserId,
  selectPrincipalUserId,
  selectActiveSubprofileId,
} from "../../sous-profile/redux/selectors/sousProfileSelectors";

const extractionLog = () => {};
const extractionError = () => {};

export const useExtraction = (
  overrideUserId = null,
  { autoLoad = true, subprofileId: overrideSubprofileId = null } = {}
) => {
  const dispatch = useDispatch();

  const effectiveUserId = useSelector(selectEffectiveUserId);
  const principalUserId = useSelector(selectPrincipalUserId);
  const activeSubprofileId = useSelector(selectActiveSubprofileId);
  const fallbackAuthUserId = useSelector(
    (state) =>
      state.auth?.user?.id ||
      state.auth?.user?._id ||
      state.auth?.currentUser?.id ||
      state.auth?.currentUser?._id ||
      state.auth?.me?.id ||
      state.auth?.me?._id ||
      state.user?.me?.id ||
      state.user?.me?._id ||
      state.user?.currentUser?.id ||
      state.user?.currentUser?._id ||
      null
  );
  const resolvedScope = useMemo(
    () =>
      resolveMedicalRecordScope({
        inputUserId: overrideUserId,
        inputSubprofileId: overrideSubprofileId,
        principalUserId,
        effectiveUserId,
        activeSubprofileId,
        fallbackUserId: fallbackAuthUserId,
      }),
    [
      activeSubprofileId,
      effectiveUserId,
      fallbackAuthUserId,
      overrideSubprofileId,
      overrideUserId,
      principalUserId,
    ],
  );
  const scopedSubprofileId = resolvedScope.subprofileId;

  useEffect(() => {
    if (effectiveUserId) {
      dispatch(fetchUserById(effectiveUserId));
    }
  }, [dispatch, effectiveUserId]);

  const fetchedUser = useSelector((state) =>
    effectiveUserId
      ? state.user?.users?.[effectiveUserId] ||
        state.user?.usersById?.[effectiveUserId] ||
        null
      : null
  );
  const patientId =
    resolvedScope.userId ||
    overrideUserId ||
    fetchedUser?.id ||
    fetchedUser?._id ||
    effectiveUserId ||
    fallbackAuthUserId ||
    null;
  const identityScope = useMemo(
    () => ({
      userId: patientId || undefined,
      subprofileId: scopedSubprofileId || undefined,
    }),
    [patientId, scopedSubprofileId]
  );

  // ── Selectors ────────────────────────────────────────────────────────────
  const processLoading       = useSelector(selectProcessLoading);
  const processResult        = useSelector(selectProcessResult);
  const processError         = useSelector(selectProcessError);
  const documents            = useSelector(selectDocuments);
  const documentsLoading     = useSelector(selectDocumentsLoading);
  const currentDocument      = useSelector(selectCurrentDocument);
  const documentLoading      = useSelector(selectDocumentLoading);
  const statistics           = useSelector(selectStatistics);
  const isHealthy            = useSelector(selectIsHealthy);
  const searchResults        = useSelector(selectSearchResults);
  const searchLoading        = useSelector(selectSearchLoading);
  const myDocuments          = useSelector(selectMyDocuments);
  const myDocumentsLoading   = useSelector(selectMyDocumentsLoading);
  const myDocumentsError     = useSelector(selectMyDocumentsError);
  const myDocumentsTotal     = useSelector(selectMyDocumentsTotal);
  const updateLoading        = useSelector(selectUpdateLoading);
  const updateError          = useSelector(selectUpdateError);
  const updateSuccess        = useSelector(selectUpdateSuccess);
  const documentHistory      = useSelector(selectDocumentHistory);
  const historyLoading       = useSelector(selectHistoryLoading);
  const historyError         = useSelector(selectHistoryError);
  const userStorage          = useSelector(selectUserStorage);
  const storageLoading       = useSelector(selectStorageLoading);
  const isStorageFull        = useSelector(selectIsStorageFull);
  const isStorageAlmostFull  = useSelector(selectIsStorageAlmostFull);
  const storageUsedMB        = useSelector(selectStorageUsedMB);
  const storageQuotaMB       = useSelector(selectStorageQuotaMB);
  const storageAvailableMB   = useSelector(selectStorageAvailableMB);
  const storageDocumentCount = useSelector(selectStorageDocumentCount);
  const storageMaxFiles      = useSelector(selectStorageMaxFiles);
  const storageAvailableFiles = useSelector(selectStorageAvailableFiles);

  // Sharing selectors
  const shareLoading         = useSelector(selectShareLoading);
  const shareError           = useSelector(selectShareError);
  const shareSuccess         = useSelector(selectShareSuccess);
  const shareResult          = useSelector(selectShareResult);
  const batchShareLoading    = useSelector(selectBatchShareLoading);
  const batchShareError      = useSelector(selectBatchShareError);
  const batchShareResult     = useSelector(selectBatchShareResult);
  const accessList           = useSelector(selectAccessList);
  const accessListLoading    = useSelector(selectAccessListLoading);
  const accessListError      = useSelector(selectAccessListError);
  const revokeLoading        = useSelector(selectRevokeLoading);
  const revokeError          = useSelector(selectRevokeError);
  const revokeSuccess        = useSelector(selectRevokeSuccess);
  const isAnySharePending    = useSelector(selectIsAnySharePending);
  const activeAccessList     = useSelector(selectActiveAccessList);
  const expiredAccessList    = useSelector(selectExpiredAccessList);
  const accessDoctorCount    = useSelector(selectAccessDoctorCount);

  // ── Local state ──────────────────────────────────────────────────────────
  const [selectedFile, setSelectedFile]           = useState(null);
  const [previewUrl, setPreviewUrl]               = useState(null);
  const [uploadProgress, setUploadProgress]       = useState(0);
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [showResultsModal, setShowResultsModal]   = useState(false);
  const [analysisSteps, setAnalysisSteps]         = useState([
    { key: 1, label: "Document Classification", completed: false },
    { key: 2, label: "OCR Processing",          completed: false },
    { key: 3, label: "Data Extraction",         completed: false },
    { key: 4, label: "Normalize and Clean Data", completed: false },
    { key: 5, label: "Anonymization",           completed: false },
  ]);

  // ── Effects ──────────────────────────────────────────────────────────────
  useEffect(() => {
    if (processLoading) return;

    dispatch(fetchUserStorage(identityScope));
    const interval = setInterval(() => {
      dispatch(fetchUserStorage(identityScope));
    }, 30000);
    return () => clearInterval(interval);
  }, [dispatch, identityScope, processLoading]);

  useEffect(() => {
    dispatch(checkExtractionHealth());
    const userId = patientId || undefined;
    extractionLog("[useExtraction] 📊 Fetching statistics for userId:", userId);
    dispatch(fetchStatistics(identityScope));
  }, [dispatch, patientId, identityScope]);

  useEffect(() => {
    if (autoLoad) {
      extractionLog("[useExtraction] 📄 Auto-loading documents for patient:", patientId);
      dispatch(fetchMyDocuments({ skip: 0, limit: 50, ...identityScope }));
    }
  }, [dispatch, patientId, autoLoad, identityScope]);

  // ── File handling ────────────────────────────────────────────────────────
  const handleFileSelect = useCallback((file) => {
    if (!file) {
      message.error("Aucun fichier sélectionné");
      return false;
    }

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/tiff",
      "image/bmp",
    ];

    if (!allowedTypes.includes(file.type)) {
      message.error("Type de fichier non supporté. Utilisez PDF ou images.");
      return false;
    }

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      message.error("Fichier trop volumineux. Taille maximale: 10MB");
      return false;
    }

    setSelectedFile(file);

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewUrl(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
    }

    return true;
  }, []);

  const simulateAnalysisSteps = useCallback(() => {
    const delays = [1000, 1500, 2000, 2500, 1500];
    setAnalysisSteps((steps) =>
      steps.map((step) => ({ ...step, completed: false }))
    );
    delays.forEach((delay, index) => {
      setTimeout(() => {
        setAnalysisSteps((steps) =>
          steps.map((step, i) =>
            i === index ? { ...step, completed: true } : step
          )
        );
      }, delays.slice(0, index + 1).reduce((a, b) => a + b, 0));
    });
  }, []);

  const handleUploadAndAnalyze = useCallback(
    async (options = {}) => {
      const {
        file: uploadFile = selectedFile,
        device = "auto",
        redactionMethod = "blackout",
        showMessages = true,
      } = options;

      if (!uploadFile) {
        if (showMessages) message.error("Veuillez sélectionner un fichier");
        return;
      }

      let progressInterval = null;

      try {
        setShowAnalysisModal(true);
        setUploadProgress(0);

        progressInterval = setInterval(() => {
          setUploadProgress((prev) => {
            if (prev >= 90) {
              clearInterval(progressInterval);
              return 90;
            }
            return prev + 10;
          });
        }, 300);

        simulateAnalysisSteps();

        const result = await dispatch(
          processDocument({
            file: uploadFile,
            device,
            redactionMethod,
            ...identityScope,
          })
        ).unwrap();

        clearInterval(progressInterval);
        setUploadProgress(100);
        if (showMessages) message.success("Document traité avec succès!");

        await Promise.all([
          dispatch(fetchStatistics(identityScope)),
          dispatch(fetchMyDocuments({ skip: 0, limit: 50, ...identityScope })),
          dispatch(fetchUserStorage(identityScope)),
        ]);
        setShowAnalysisModal(false);

        setSelectedFile(null);
        setPreviewUrl(null);
        setUploadProgress(0);

        return result;
      } catch (error) {
        if (progressInterval) clearInterval(progressInterval);
        setShowAnalysisModal(false);
        if (showMessages) {
          message.error(
            error?.message || error || "Erreur lors du traitement du document"
          );
        }
        setUploadProgress(0);
        if (!showMessages) throw error;
        return null;
      }
    },
    [selectedFile, dispatch, simulateAnalysisSteps, identityScope]
  );

  const handleSaveResults = useCallback(() => {
    if (processResult) {
      message.success("Résultats sauvegardés avec succès!");
      setShowResultsModal(false);
      dispatch(resetProcessResult());
    }
  }, [processResult, dispatch]);

  const handleCloseAnalysisModal = useCallback(() => {
    setShowAnalysisModal(false);
  }, []);

  const handleCloseResultsModal = useCallback(() => {
    setShowResultsModal(false);
    dispatch(resetProcessResult());
  }, [dispatch]);

  // ── Document CRUD ────────────────────────────────────────────────────────
  const loadDocuments = useCallback(
    (collection, skip = 0, limit = 10) => {
      return dispatch(fetchDocuments({ collection, skip, limit, ...identityScope }));
    },
    [dispatch, identityScope]
  );

  const loadMyDocuments = useCallback(
    (skip = 0, limit = 50, overrideUserId = null) => {
      const userId = overrideUserId || patientId || undefined;
      extractionLog("[useExtraction] 📞 loadMyDocuments called with userId:", userId);
      const scope = overrideUserId
        ? { userId, subprofileId: undefined }
        : identityScope;
      return dispatch(fetchMyDocuments({ skip, limit, ...scope }));
    },
    [dispatch, identityScope]
  );

  const loadAllRecentDocuments = useCallback(
    (skip = 0, limit = 10) => {
      return dispatch(fetchAllRecentDocuments({ skip, limit, ...identityScope }));
    },
    [dispatch, identityScope]
  );

  const loadDocumentsByType = useCallback(
    (type, skip = 0, limit = 50) => {
      const userId = patientId || undefined;
      extractionLog("[useExtraction] 📞 loadDocumentsByType:", type, "userId:", userId);
      return dispatch(fetchDocumentsByType({ type, skip, limit, ...identityScope }));
    },
    [dispatch, identityScope]
  );

  const loadDocument = useCallback(
    (collection, id) => {
      return dispatch(fetchDocumentById({ collection, id, ...identityScope }));
    },
    [dispatch, identityScope]
  );

  const removeDocument = useCallback(
    async (collection, id) => {
      extractionLog("[useExtraction] 🗑️ removeDocument:", { collection, id, patientId });

      if (!id) {
        message.error("Invalid document ID");
        return false;
      }

      try {
        const normalizedCollection = String(collection || "autre")
          .toLowerCase()
          .replace(/-/g, "_");

        await dispatch(
          deleteDocument({ collection: normalizedCollection, id, ...identityScope })
        ).unwrap();

        extractionLog("[useExtraction] ✅ Delete successful");
        message.success("Document deleted!");

        dispatch(fetchStatistics(identityScope));
        dispatch(fetchMyDocuments({ skip: 0, limit: 50, ...identityScope }));
        dispatch(fetchUserStorage(identityScope));

        return true;
      } catch (error) {
        extractionError("[useExtraction] ❌ Delete failed:", error);
        message.error(error || "Failed to delete document");
        return false;
      }
    },
    [dispatch, patientId, identityScope]
  );

  const searchDocs = useCallback(
    (collection, query, field = "nom_fichier") => {
      return dispatch(searchDocuments({ collection, query, field, ...identityScope }));
    },
    [dispatch, identityScope]
  );

  const refreshAllData = useCallback(() => {
    const userId = patientId || undefined;
    extractionLog("[useExtraction] 🔄 Refreshing all data for userId:", userId);
    return Promise.all([
      dispatch(checkExtractionHealth()),
      dispatch(fetchStatistics(identityScope)),
      dispatch(fetchMyDocuments({ skip: 0, limit: 50, ...identityScope })),
      dispatch(fetchUserStorage(identityScope)),
    ]);
  }, [dispatch, identityScope]);

  const resetFileSelection = useCallback(() => {
    setSelectedFile(null);
    setPreviewUrl(null);
    setUploadProgress(0);
  }, []);

  const resetAllResults = useCallback(() => {
    dispatch(resetProcessResult());
    dispatch(resetDocuments());
    dispatch(resetMyDocuments());
    dispatch(resetCurrentDocument());
    dispatch(resetSearchResults());
  }, [dispatch]);

  const updateParameters = useCallback(
    async (collection, id, updateData, version = null) => {
      try {
        const result = await dispatch(
          updateDocumentParameters({
            collection,
            id,
            updateData,
            version,
            ...identityScope,
          })
        ).unwrap();
        message.success(`${updateData.modifications?.length || 0} modifications saved!`);
        dispatch(fetchStatistics(identityScope));
        dispatch(fetchMyDocuments({ skip: 0, limit: 50, ...identityScope }));
        dispatch(fetchUserStorage(identityScope));
        return result;
      } catch (error) {
        message.error(error || "Failed to update parameters");
        return null;
      }
    },
    [dispatch, patientId, identityScope]
  );

  const getDocumentHistory = useCallback(
    async (collection, id) => {
      extractionLog("[useExtraction] 📜 getDocumentHistory:", { collection, id });
      try {
        const result = await dispatch(
          fetchDocumentHistory({ collection, id, ...identityScope })
        ).unwrap();
        extractionLog("[useExtraction] ✅ History fetched");
        return result;
      } catch (error) {
        extractionError("[useExtraction] ❌ History fetch failed:", error);
        message.error(error || "Failed to fetch history");
        return null;
      }
    },
    [dispatch, identityScope]
  );

  const resetUpdate = useCallback(() => {
    dispatch(resetUpdateState());
  }, [dispatch]);

  const getUserStorage = useCallback(async () => {
    try {
      await dispatch(fetchUserStorage(identityScope)).unwrap();
    } catch (error) {
      extractionError("[useExtraction] ❌ Error fetching storage:", error);
      throw error;
    }
  }, [dispatch, identityScope]);

  const recalculateStorage = useCallback(async () => {
    try {
      await dispatch(recalculateUserStorage(identityScope)).unwrap();
      dispatch(fetchStatistics(identityScope));
    } catch (error) {
      extractionError("[useExtraction] ❌ Error recalculating storage:", error);
      throw error;
    }
  }, [dispatch, identityScope]);

  // ── Sharing ──────────────────────────────────────────────────────────────
  const shareDoc = useCallback(
    async (documentId, doctorIds = [], expiresInHours = null) => {
      if (!documentId) {
        message.error("ID de document manquant");
        return null;
      }
      if (!doctorIds.length) {
        message.error("Sélectionnez au moins un médecin");
        return null;
      }

      try {
        const result = await dispatch(
          shareDocument({ documentId, doctorIds, expiresInHours })
        ).unwrap();

        message.success("Document partagé avec succès");
        return result;
      } catch (error) {
        extractionError("[useExtraction] ❌ shareDoc failed:", error);
        message.error(
          typeof error === "string" ? error : "Erreur lors du partage"
        );
        return null;
      }
    },
    [dispatch]
  );

  const shareDocs = useCallback(
    async (documents = [], doctorIds = [], expiresInHours = null) => {
      if (!documents.length) {
        message.error("Aucun document à partager");
        return null;
      }
      if (!doctorIds.length) {
        message.error("Sélectionnez au moins un médecin");
        return null;
      }

      try {
        const result = await dispatch(
          shareDocuments({ documents, doctorIds, expiresInHours })
        ).unwrap();

        const { totalShared, totalFailed } = result;

        if (totalShared > 0) {
          message.success(`${totalShared} document(s) partagé(s) avec succès`);
        }
        if (totalFailed > 0) {
          message.warning(`${totalFailed} document(s) n'ont pas pu être partagés`);
        }

        return result;
      } catch (error) {
        extractionError("[useExtraction] ❌ shareDocs failed:", error);
        message.error(
          typeof error === "string" ? error : "Erreur lors du partage"
        );
        return null;
      }
    },
    [dispatch]
  );

  const loadDocumentAccessList = useCallback(
    async (documentId) => {
      if (!documentId) {
        message.error("ID de document manquant");
        return null;
      }

      try {
        const result = await dispatch(
          fetchDocumentAccessList({ documentId })
        ).unwrap();
        return result;
      } catch (error) {
        extractionError("[useExtraction] ❌ loadDocumentAccessList failed:", error);
        message.error("Erreur lors de la récupération des accès");
        return null;
      }
    },
    [dispatch]
  );

  const revokeAccess = useCallback(
    async (documentId, doctorIds = []) => {
      if (!documentId) {
        message.error("ID de document manquant");
        return false;
      }
      if (!doctorIds.length) {
        message.error("Aucun médecin spécifié");
        return false;
      }

      try {
        await dispatch(
          revokeDocumentAccess({ documentId, doctorIds })
        ).unwrap();

        message.success("Accès révoqué avec succès");
        return true;
      } catch (error) {
        extractionError("[useExtraction] ❌ revokeAccess failed:", error);
        message.error("Erreur lors de la révocation de l'accès");
        return false;
      }
    },
    [dispatch]
  );

  const resetShare      = useCallback(() => dispatch(resetShareState()),      [dispatch]);
  const resetBatchShare = useCallback(() => dispatch(resetBatchShareState()), [dispatch]);
  const resetAccess     = useCallback(() => dispatch(resetAccessList()),      [dispatch]);
  const resetRevoke     = useCallback(() => dispatch(resetRevokeState()),     [dispatch]);

  // ── Return ───────────────────────────────────────────────────────────────
  return {
    // Local state
    selectedFile,
    previewUrl,
    uploadProgress,
    showAnalysisModal,
    showResultsModal,
    analysisSteps,

    // Process
    processLoading,
    processResult,
    processError,

    // Documents
    documents,
    documentsLoading,
    currentDocument,
    documentLoading,
    myDocuments,
    myDocumentsLoading,
    myDocumentsError,
    myDocumentsTotal,

    // Stats & health
    statistics,
    isHealthy,

    // Search
    searchResults,
    searchLoading,

    // Update
    updateLoading,
    updateError,
    updateSuccess,

    // History
    documentHistory,
    historyLoading,
    historyError,

    // Storage
    userStorage,
    storageLoading,
    isStorageFull,
    isStorageAlmostFull,
    storageUsedMB,
    storageQuotaMB,
    storageAvailableMB,
    storageDocumentCount,
    storageMaxFiles,
    storageAvailableFiles,

    // Sharing state
    shareLoading,
    shareError,
    shareSuccess,
    shareResult,
    batchShareLoading,
    batchShareError,
    batchShareResult,
    accessList,
    accessListLoading,
    accessListError,
    revokeLoading,
    revokeError,
    revokeSuccess,
    isAnySharePending,
    activeAccessList,
    expiredAccessList,
    accessDoctorCount,

    // File actions
    handleFileSelect,
    handleUploadAndAnalyze,
    handleSaveResults,
    handleCloseAnalysisModal,
    handleCloseResultsModal,
    resetFileSelection,

    // Document actions
    loadDocuments,
    loadMyDocuments,
    loadAllRecentDocuments,
    loadDocumentsByType,
    loadDocument,
    removeDocument,
    searchDocs,
    refreshAllData,
    resetAllResults,
    updateParameters,
    getDocumentHistory,
    resetUpdate,

    // Storage actions
    getUserStorage,
    recalculateStorage,

    // Sharing actions
    shareDoc,
    shareDocs,
    loadDocumentAccessList,
    revokeAccess,
    resetShare,
    resetBatchShare,
    resetAccess,
    resetRevoke,

    // Setters
    setShowAnalysisModal,
    setShowResultsModal,
  };
};

export default useExtraction;
